// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"7a91e728","618":"d6cd5c5e","996":"be0311f9"}[chunkId] + ".chunk.js";
};